<template>
  <StyledDiv margin="75px 0 0 20px" class="adjustMargin">
    <StyledText
      :fontFamily="styled('fontFamily-GothamMedium')"
      :fontSize="styled('fontSize-medium')"
      margin="15px 0"
    >
      Literacy Loom Features
    </StyledText>
    <StyledDiv justifyContent="center" flexDirection="row" flexWrap="Wrap">
      <SingleFeature v-for="(f, i) in feats" :key="i" :info="f" />
    </StyledDiv>
  </StyledDiv>
</template>

<script>
import { featureList } from "../helpers/featureList";
import SingleFeature from "./SingleFeature";
import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
export default {
  components: {
    StyledDiv,
    StyledText,
    SingleFeature
  },
  data() {
    return {
      feats: featureList
    };
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
@media (max-width: 500px) {
  .adjustMargin {
    margin: 0 0 20px 0;
  }
}
</style>
